export interface CacheStore {
  getValue<T>(key: string): Promise<{ value: T } | undefined>;
  setValue<T>(key: string, value: T, ttlSeconds?: number): Promise<void>;
  deleteValue(key: string): Promise<void>;
}

export class CachePool {
  constructor(
    private readonly store: CacheStore,
  ) {}

  async runTask<T = unknown>(
    key: string,
    task: () => Promise<T>,
    ttlSeconds?: number,
  ): Promise<T> {
    const cachedValue = await this.store.getValue<T>(key);

    if (cachedValue) {
      return cachedValue.value;
    }

    const result = await task();

    try {
      await this.store.setValue(key, result, ttlSeconds);
    } catch (err) {
      console.error(`Failed when saving cache for key ${key}`, err);
    }

    return result;
  }
}
